<div>{{title}}</div>

<div cdkDropList (cdkDropListDropped)="onCdkDropListDropped($event)" class="drag-drop-group">
  @for (item of items; track item) {
    <div cdkDrag class="drag-drop-group-item">
      {{getDisplay(item)}}
    </div>
  }
</div>